import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { EffectiveOrgService } from '../data/services/effective-org.service';

@Injectable()
export class OrgHeadersInterceptor implements HttpInterceptor {
    constructor(private readonly effectiveOrgService: EffectiveOrgService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Requests that fire before APP_INITIALIZER completes (e.g. the org-switcher
        // bootstrap call) receive a null org and are forwarded without org headers.
        // Org headers are guaranteed only after primeEffectiveOrg() has run.
        return this.effectiveOrgService.effectiveOrg$.pipe(
            take(1),
            switchMap(effectiveOrg => {
                if (!effectiveOrg?.uid) {
                    return next.handle(request);
                }
                const headers: Record<string, string[]> = { 'X-ORG-UIDS': [effectiveOrg.uid] };
                // Never stamp String(undefined/null/NaN): legacy-only readers would treat it as malformed
                // (CLOUD-278784).
                const legacyOrgId = String(effectiveOrg.id);
                if (/^\d+$/.test(legacyOrgId)) {
                    headers['X-LEGACY-ORG-IDS'] = [legacyOrgId];
                }
                return next.handle(request.clone({ setHeaders: headers }));
            }),
        );
    }
}
